<div class="modal fade" id="propertyFormModal" msEscClose
    (escPressed)="onCancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">
                    @if (formState() === FormState.Update) {
                        Edit Property
                    } @else {
                        Add Property to<br />{{ organization()?.name }}
                    }
                </h5>
            </div>
            <div class="modal-body text-center">
                <ms-property-form [organization]="organization()" [property]="property()" [formState]="formState()"
                    (submissionResult)="onPropertyResult($event)" (cancelRequested)="onCancel()"
                    (editConfirmationRequested)="onEditConfirmationRequested()"
                    (addressVerificationRequested)="onAddressVerificationRequested($event)"
                    (addressVerificationUnavailable)="onAddressVerificationUnavailable()"
                    (addressVerificationRejected)="onAddressVerificationRejected($event)">
                </ms-property-form>
            </div>
        </div>
    </div>
</div>

<ms-info-modal #addPropertyInfoModalRef modalId="addPropertyInfoModal" (onConfirm)="infoModalConfirmed()" />

<ms-confirmation-modal
    #addPropertyConfirmationModalRef
    modalId="addPropertyConfirmationModal"
    confirmButtonText="Leave"
    cancelButtonText="Stay"
    (confirmed)="confirmationModalConfirmed()"
    (cancelled)="confirmationModalCancelled()"
/>

<ms-confirmation-modal
    #editPropertyConfirmationModalRef
    modalId="editPropertyConfirmationModal"
    confirmButtonText="Save"
    cancelButtonText="Cancel"
    (confirmed)="editConfirmationModalConfirmed()"
    (cancelled)="editConfirmationModalCancelled()"
/>

@if (isAddressVerificationEnabled()) {
    <ms-address-verification-modal
        modalId="addressVerificationModal"
        [prompt]="addressVerificationPrompt()"
        (confirmed)="addressVerificationConfirmed($event)"
        (editRequested)="addressVerificationEditRequested()"
    />

    <ms-confirmation-modal
        #addressVerificationUnavailableModalRef
        modalId="addressVerificationUnavailableModal"
        confirmButtonText="Save"
        cancelButtonText="Cancel"
        (confirmed)="addressVerificationUnavailableConfirmed()"
        (cancelled)="addressVerificationUnavailableCancelled()"
    />
}
